import { render } from "./WidgetsPanelButton.vue?vue&type=template&id=610c420a"
import script from "./WidgetsPanelButton.vue?vue&type=script&lang=ts"
export * from "./WidgetsPanelButton.vue?vue&type=script&lang=ts"
script.render = render

export default script